module.exports = require("remark-parse");


//////////////////
// WEBPACK FOOTER
// external "remark-parse"
// module id = 58
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13